import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';
import { type Registry as Services, service } from '@ember/service';
import ActionBookingsRepliesIndexController from 'uplisting-frontend/pods/action/bookings/replies/index/controller';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import type { RhsRecord } from 'uplisting-frontend/utils/rhs/types';
import { getParentRouteRecordKey } from 'uplisting-frontend/utils/rhs/helpers';

export default abstract class SidebarBookingsRepliesIndexRoute extends BaseRoute {
  @service('repositories/saved-reply')
  savedReplyRepository!: Services['repositories/saved-reply'];

  abstract parentRoute: string;

  model() {
    const record = this.modelFor(this.parentRoute) as RhsRecord;

    return hash({
      [getParentRouteRecordKey(this.parentRoute)]: record,
      savedReplies: this.savedReplyRepository.findAll(),
    });
  }

  setupController(
    controller: ActionBookingsRepliesIndexController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, model);
  }
}
